export enum ImportDataTypeEnum {
    Default = 1,
    Capability = 2,
}
